// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pd-c";
export var backButton = "_pd-4";
export var backIcon = "_pd-5";
export var chevronShortcut = "_pd-6";
export var container = "_pd-1";
export var editor = "_pd-8";
export var editorWrapper = "_pd-7";
export var prefix = "_pd-2";
export var searchIcon = "_pd-3";
export var suffix = "_pd-9";
export var suffixContent = "_pd-a";
export var suffixText = "_pd-b";
export var wrapper = "_pd-0";